'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #fff;\n  background-image: url(', ');\n  background-position: center;\n  background-size: cover;\n  overflow: auto;\n'], ['\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #fff;\n  background-image: url(', ');\n  background-position: center;\n  background-size: cover;\n  overflow: auto;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoothBackground = _styledComponents2.default.div(_templateObject, function (props) {
  return props.image;
});

/** @class BoothBackground
  * A component providing the background to a booth.
  * @param {URLString} image - the image to display.
  */
exports.default = BoothBackground;


BoothBackground.propTypes = {
  image: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/booth/booth-background.js
// module id = 1331
// module chunks = 0